import { render, staticRenderFns } from "./QuestionAlreadyAnsweredRoute.vue?vue&type=template&id=6a5b6fc4&scoped=true&"
import script from "./QuestionAlreadyAnsweredRoute.vue?vue&type=script&lang=js&"
export * from "./QuestionAlreadyAnsweredRoute.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAlreadyAnsweredRoute.vue?vue&type=style&index=0&id=6a5b6fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b6fc4",
  null
  
)

export default component.exports